const ACTIONS = ['photo_reuse_renamed', 'photo_reuse_delayed', 'photo_reuse_recovered'];

function description(action, count) {
    if (action === 'photo_reuse_delayed') return `Переименование отложено. Файлов: ${count}. Система повторит попытку автоматически.`;
    if (action === 'photo_reuse_recovered') return `Переименование восстановлено. Файлов: ${count}.`;
    return `Файлы переименованы для нового отчёта. Всего: ${count}.`;
}

// Older events were written per file. Group their presentation without rewriting
// the audit trail. A destination report identifies a submission, not a time window.
function group(history) {
    const groups = new Map();
    const result = [];
    for (const item of history || []) {
        const changes = item.changes || [];
        const target = changes[0] && changes[0].target_report_id;
        if (!ACTIONS.includes(item.action) || !target || !changes.length ||
            changes.some(change => !change.media_id || Number(change.target_report_id) !== Number(target))) {
            result.push(item);
            continue;
        }
        const key = [item.report_id, item.action, target, item.user_id || 0].join(':');
        let entry = groups.get(key);
        if (!entry) {
            entry = {...item, changes: []};
            groups.set(key, entry);
            result.push(entry);
        }
        for (const change of changes) {
            if (!entry.changes.some(existing => Number(existing.media_id) === Number(change.media_id))) entry.changes.push({...change});
        }
        if (new Date(item.created_at) > new Date(entry.created_at)) entry.created_at = item.created_at;
        entry.description = description(entry.action, entry.changes.length);
    }
    return result;
}

module.exports = {description, group};
